import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Transaction } from '../models';

@Injectable({
  providedIn: 'root',
})
export class TokenServiceService {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly jwt: JwtHelperService
  ) { }

  private token: string;
  clientInfoData: any;
  codeValidToken: number;

  getCodeValidToken(): number {
    return this.codeValidToken;
  }

  setCodeValidToken(value: number): void {
    this.codeValidToken = value;
  }

  getToken() {
    if (!this.token) {
      this.token = this.route.snapshot.queryParamMap.get('token');
    }
    return this.token;
  }

  getAndDecodeToken() {
    return this.jwt.decodeToken(this.getToken());
  }

  getAndDecodeCustomToken(token) {
    return this.jwt.decodeToken(token);
  }

  /**
   * @description {exitsAdditionalInformation} Function to validate if the additional information of the user exists
   * @param decodedToken
   * @returns
  */
  exitsAdditionalInformation(decodedToken: Transaction) {
    const { ADDITIONAL_INFORMATION } = decodedToken;
    return ADDITIONAL_INFORMATION ? ADDITIONAL_INFORMATION : false;
  }
  /**
   *
   * @description {isEditableInfo} Function to validate if the information can be editable by the user
   * @param additionalInformation
   * @returns isEditableInfo
  */
  isEditableInfo(additionalInformation: any) {
    const { checkout } = additionalInformation;
    if (checkout) {
      const { fields } = checkout;
      const { personal_information } = fields;
      return personal_information.editable ?? true;
    };
    return true;
  }
}
